import React from 'react'
import { Field, reduxForm } from 'redux-form'
import Captcha from '../../Captcha'
import { normalizeData, validaData } from '../../normalizes/Normalizes'

const validate = values => {
  const requiredMsg = "Este campo é obrigatório";
  const errors = {};

  if (!values.codigoUso) {
    errors.codigoUso = requiredMsg;
  }

  if (!values.dataNascimento) {
    errors.dataNascimento = requiredMsg;
  } else if (!validaData(values.dataNascimento)) {
    errors.dataNascimento = "Por favor, digite uma data válida."
  }

  if (!values.captcharesponse){
    errors.captcharesponse = "Por favor, confirme o Captcha"
  }

  return errors
}

const renderField = ({input, label, type, placeholder, meta: {touched, error, warning}}) => (
  <div className='form-group'>
    <label htmlFor={input.name}>{label}</label>
    <input {...input} id={input.name} type={type} placeholder={placeholder}
           className={`form-control ${touched && ((error && 'is-invalid'))}`}
    />
    {touched && (error && <span className='text-danger'>{error}</span>)}
  </div>
)

const FormValidador = props => {
  const {handleSubmit, submitting} = props;
  return (
    <form onSubmit={handleSubmit}>

        <Field name="codigoUso" type="text" component={renderField} label="Código de uso" placeholder='Código de uso'/>

        <Field name="dataNascimento" type="text" component={renderField} label="Data de Nascimento"
               normalize={normalizeData} placeholder="__/__/____"/>

        <div className="form-group text-center">

          <Field name='captcharesponse' component={Captcha}/>

          <button type="submit" disabled={submitting} className='btn btn-block btn-success'>Validar</button>
        </div>

    </form>
  )
}

export default reduxForm({
  form: 'formValidador',
  fields: ['codigoUso', 'dataNascimento', 'captcharesponse'],
  validate
})(FormValidador)



// WEBPACK FOOTER //
// ./src/components/views/Validador/FormValidador.js